import networking from './networking'

const Endpoint = {
  categories: (uuid) => '/categories' + (!uuid ? '' : '/' + uuid),
  contactUs: () => 'contact_us',
  performers: (uuid) => '/performers' + (!uuid ? '' : '/' + uuid),
  regions: () => '/regions',
  sessions: () => '/sessions',
  songCategoryCreate: () => '/song_category/create',
  songCategoryDelete: () => '/song_category/delete',
  songs: (uuid) => '/songs' + (!uuid ? '' : '/' + uuid),
  users: () => '/users',
}

class ApiClient {

  // Category
  getCategories = (options) => networking.get(Endpoint.categories(), { params: options })
  createCategory = (category) => networking.post(Endpoint.categories(), category)
  updateCategory = (category) => networking.put(Endpoint.categories(category.id), category)
  deleteCategory = (category) => networking.delete(Endpoint.categories(category.id))

  // Contact Us
  sendContactUsMessage = (form) => networking.post(Endpoint.contactUs(), form)

  // Performer
  getPerformers = (options) => networking.get(Endpoint.performers(), { params: options })
  createPerformer = (performer) => networking.post(Endpoint.performers(), performer)
  updatePerformer = (performer) => networking.put(Endpoint.performers(), performer)
  deletePerformer = (performer) => networking.delete(Endpoint.performers(performer.id))

  // Region
  getRegions = () => networking.get(Endpoint.regions())

  // Session
  logIn = (user) => networking.post(Endpoint.sessions(), user)

  // SongCategory
  createSongCategory = (object) => networking.post(Endpoint.songCategoryCreate(), object)
  deleteSongCategory = (object) => networking.post(Endpoint.songCategoryDelete(), object)

  // Song
  getSongs = (options) => networking.get(Endpoint.songs(), { params: options })
  createSong = (song) => networking.post(Endpoint.songs(), song)
  updateSong = (song) => networking.put(Endpoint.songs(song.id), song)
  deleteSong = (song) => networking.delete(Endpoint.songs(song.id))

  // User
  createUser = (user) => networking.post(Endpoint.users(), user)

  // Token management
  setToken(token) {
    networking.setToken(token)
  }

  removeToken() {
    networking.removeToken()
  }
}

export default new ApiClient()
